export default class Signature {
    constructor (dto) {        
        this.name = ''
        this.date = ''
        this.entity = ''
        this.validFrom = ''
        this.validTo = ''
        this.isValid = false

        if (dto) {            
            this.name = dto.Name
            this.date = dto.Date
            this.entity = dto.Entity
            this.validFrom = dto.ValidFrom
            this.validTo = dto.ValidTo
            this.isValid = dto.IsValid
        }
    }
}